/*
  mayie-pdp2-final-nav.js: navigarea în pagină a șablonului product.info-final (sections/mayie-pdp2-final-nav.liquid).
  Preluat din direcția B (assets/mayie-pdp2-info-b.js) și adaptat la secțiunile separate din Shopify, unde
  position: sticky nu poate trece de la o secțiune la alta:
    1. scoate butoanele a căror ancoră nu există în pagină (un subiect fără date nu randează nimic);
    2. rândul devine position: fixed când locul lui din flux iese pe sus din ecran (de la primul subiect) și se
       ascunde când ancora #recenzii ajunge în treimea de sus; locul din flux rămâne rezervat (fără salt de pagină).
       Starea se citește din poziții doar în callback-urile IntersectionObserver;
    3. marchează butonul subiectului din ecran (aria-current="location") și îl aduce în vedere doar orizontal
       (poziția din dreptunghiurile rândului, deci corectă și cu rândul deja derulat sau fix);
    4. la click derulează lin sub bară (+ antetul Dawn „on-scroll-up” când reapare la derularea în sus);
    5. pe telefon rândul e mai lat decât ecranul: clasele is-more-right / is-more-left (estomparea din CSS) arată că mai
       sunt butoane într-o parte; le pune un IntersectionObserver cu rândul ca rădăcină, pe primul și ultimul buton.
  Doar IntersectionObserver, fără ascultători de scroll. Fără JS sau fără IntersectionObserver: linkuri-ancoră simple.
*/
(() => {
  const wrap = document.querySelector('[data-pdp2f-navwrap]');
  if (!wrap) return;
  const nav = wrap.querySelector('[data-pdp2f-nav]');
  const row = nav && nav.querySelector('.mayie-pdp2f-nav__list');
  if (!nav || !row) return;

  nav.querySelectorAll('a[href^="#"]').forEach((a) => {
    if (!document.getElementById(a.getAttribute('href').slice(1))) a.closest('li').remove();
  });
  const links = Array.from(nav.querySelectorAll('a[href^="#"]'));
  if (links.length < 2) {
    wrap.remove();
    return;
  }
  if (!('IntersectionObserver' in window)) return;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // 5. Estomparea la marginea dinspre butoanele care nu încap (doar când rândul e mai lat decât ecranul).
  const firstLi = row.firstElementChild;
  const lastLi = row.lastElementChild;
  const edgeRowIo = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        const cls = e.target === firstLi ? 'is-more-left' : 'is-more-right';
        row.classList.toggle(cls, e.intersectionRatio < 0.98);
      });
    },
    { root: row, threshold: [0, 0.98, 1] }
  );
  edgeRowIo.observe(firstLi);
  if (lastLi !== firstLi) edgeRowIo.observe(lastLi);

  const chips = new Map(links.map((a) => [a.dataset.topic, a]));
  const topics = Array.from(document.querySelectorAll('[data-pdp2f-topic]'));
  const end = document.getElementById('recenzii');

  // Locul din flux rămâne cât rândul, și când rândul e fix.
  wrap.style.minHeight = `${nav.offsetHeight}px`;

  let current = null;
  let stuck = false;
  let ended = false;
  const update = () => {
    stuck = wrap.getBoundingClientRect().top < 0;
    ended = end ? end.getBoundingClientRect().top < window.innerHeight * 0.35 : false;
    nav.classList.toggle('is-fixed', stuck);
    nav.classList.toggle('is-away', stuck && ended);
    // Înapoi în flux (deasupra subiectelor): niciun buton activ, rândul de la început.
    if (!stuck) setCurrent(null);
  };

  // 2. Starea se recalculează la orice schimbare de vizibilitate a secțiunii de cumpărare, a locului din flux, a
  // subiectelor și a ancorei #recenzii: ele acoperă pagina până la recenzii, deci și un salt (tasta Home, butonul
  // „sus”, un link) schimbă cel puțin una și starea nu rămâne veche. Pragul 1 prinde momentul în care locul din flux
  // începe să iasă pe sus; rootMargin-ul de jos prinde #recenzii când intră în treimea de sus a ecranului.
  const watch = [wrap, ...topics];
  const buy = wrap.closest('.shopify-section') && wrap.closest('.shopify-section').previousElementSibling;
  if (buy) watch.push(buy);
  const edgeIo = new IntersectionObserver(update, { threshold: [0, 1] });
  watch.forEach((el) => edgeIo.observe(el));
  if (end) new IntersectionObserver(update, { rootMargin: '0px 0px -65% 0px' }).observe(end);

  // 3. Subiectul activ = primul care atinge banda dintre 25% și 45% din înălțimea ecranului (bara de cumpărare
  // de jos stă sub bandă, deci nu ascunde subiectul).
  function setCurrent(topic) {
    if (topic === current) return;
    current = topic;
    chips.forEach((a, key) => {
      if (key === topic) a.setAttribute('aria-current', 'location');
      else a.removeAttribute('aria-current');
    });
    if (row.scrollWidth <= row.clientWidth) return;
    const a = topic && chips.get(topic);
    const left = a
      ? row.scrollLeft + a.getBoundingClientRect().left - row.getBoundingClientRect().left - (row.clientWidth - a.offsetWidth) / 2
      : 0;
    row.scrollTo({ left: Math.max(0, left), behavior: reduce ? 'auto' : 'smooth' });
  }
  const inBand = new Set();
  const bandIo = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => (e.isIntersecting ? inBand.add(e.target) : inBand.delete(e.target)));
      const first = topics.find((t) => inBand.has(t));
      if (first) setCurrent(first.dataset.pdp2fTopic);
      else if (topics[0] && topics[0].getBoundingClientRect().top > window.innerHeight * 0.45) setCurrent(null);
    },
    { rootMargin: '-25% 0px -55% 0px' }
  );
  topics.forEach((t) => bandIo.observe(t));

  // 4. Click: subiectul ajunge chiar sub bară. În jos antetul Dawn se ascunde, deci lăsăm loc doar pentru bară;
  // în sus antetul reapare, deci lăsăm loc și pentru el.
  nav.addEventListener('click', (e) => {
    const a = e.target.closest('a[href^="#"]');
    if (!a) return;
    const target = document.getElementById(a.getAttribute('href').slice(1));
    if (!target) return;
    e.preventDefault();
    const top = target.getBoundingClientRect().top;
    const header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
    const offset = nav.offsetHeight + (top < 0 ? header : 0) + 8;
    window.scrollTo({ top: window.scrollY + top - offset, behavior: reduce ? 'auto' : 'smooth' });
    if (history.replaceState) history.replaceState(null, '', a.getAttribute('href'));
  });
})();
